module.exports = __webpack_public_path__ + "img/BTCD-alt.35ff9e50.svg";